<deprecated-labeled-field
  [label]="label"
  [help]="help"
  [required]="required"
  [labelDirection]="labelDirection"
  [actionText]="actionText"
  (action)="action.emit()"
  (mousedown)="$event.stopPropagation()"
>
  <div class="container">
    <!--I apologize if anyone has to ever mess with this janky prefix logic. These things might be confusing:
      The inputElement.getBounding... is supposed to keep the benefit within the div.
      The prefixBufferElement is supposed to keep the prefix just in front of the value.-->
    <div
      *ngIf="prefix"
      (clientSize)="prefixElement = $event"
      [ngClass]="prefixClasses"
      [style.margin-right.px]="
        rightAlignedPrefix
          ? !!prefixBufferElement?.width
            ? prefixBufferElement!.width <
              inputElement.getBoundingClientRect().width - 36
              ? prefixBufferElement!.width + 2
              : inputElement.getBoundingClientRect().width - 36
            : 30
          : null
      "
    >
      <ng-container *ngTemplateOutlet="prefix"></ng-container>
      <p
        (clientSize)="prefixBufferElement = $event"
        display="none"
        class="ix-buffer"
      >
        {{ inputElement.value }}
      </p>
    </div>
    <input
      #inputElement
      [class.error]="error"
      [class.warning]="warning"
      [class.combined-left]="combinedLeft"
      [class.combined-right]="combinedRight"
      [ngClass]="classes"
      [placeholder]="placeholder"
      [type]="type"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [value]="value"
      (input)="value = $event.target.value"
      (keydown)="keydown.emit($event)"
      [focusOnInit]="autoFocus"
      [style.padding-left.px]="
        !rightAlignedSuffix && !!prefixElement?.width
          ? prefixElement!.width + 12
          : null
      "
      [style.padding-right.px]="rightAlignedSuffix ? 20 : null"
      [style.text-align]="textAlign"
      [style.font-size]="fontSize ? fontSize : null"
      [attr.maxlength]="maxLength"
      [attr.minlength]="minLength"
      [min]="min"
      [max]="max"
      [step]="step"
      (blur)="onInputBlur(); blur.emit($event)"
      (focus)="focusEvent.emit($event)"
      tabindex="0"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    />
    <div
      *ngIf="suffix"
      (clientSize)="suffixElement = $event"
      [ngClass]="suffixClasses"
      [style.margin-left.px]="
        rightAlignedSuffix
          ? null
          : !!suffixBufferElement?.width
            ? suffixBufferElement!.width + 2
            : 10
      "
    >
      <p
        (clientSize)="suffixBufferElement = $event"
        display="none"
        class="ix-buffer"
      >
        {{ inputElement.value }}
      </p>
      <ng-container *ngTemplateOutlet="suffix"></ng-container>
    </div>
  </div>
</deprecated-labeled-field>
